<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">
    <span class="primary hover" (click)="onBack()">Order templates</span>
    <i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
    {{ isNew ? 'New template' : 'Template details' }}
  </div>
</div>

@if (template?.isDefault) {
  <div class="padding bg-orange flex center">
    <i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
    <span>
      This is a
      <b>default template</b>
      . Edit is not available.
    </span>
  </div>
}

<div class="padding-large m-padding">
  <div class="page-layout">
    <div class="flex between m-column m-start">
      <div class="flex center">
        <h4>Template Details</h4>
      </div>

      <div class="flex center m-margin-top">
        <button (click)="saveTemplate()" [disabled]="!isNew">
          <i class="fa-solid fa-save"></i>
          Save Changes
        </button>
      </div>
    </div>
    @if (template) {
      <!-- <div class="flex center between margin-top">
				<div class="flex column">
					Template name (automatically generated):
					<input type="text" [(ngModel)]="template.name" [disabled]="true" class="margin-top-smallest fix-width" />
				</div>
			</div> -->

      <div class="flex margin-top-large">
        <div class="flex-1 flex column">
          <b class="flex center padding-top-small padding-bottom-small">Product conditions :</b>
          <div class="border padding dashed">
            <div class="flex column">
              Brand:

              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (template?.brand) {
                    <b class="primary">{{ template.brand.name }}</b>
                  } @else {
                    <span class="grey">All brands</span>
                  }
                </div>
                <button class="radius-left-none" (click)="openBrandFilterModal()" [disabled]="!isNew">
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top  {{ !canSelectCollectionAndCategory() ? 'disabled' : '' }}">
              Collection:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (template?.collection) {
                    <b class="primary">{{ template.collection.name }}</b>
                  } @else {
                    <span class="grey">All collections</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openCollectionFilterModal()"
                  [disabled]="!isNew || !canSelectCollectionAndCategory()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top  {{ !canSelectCollectionAndCategory() ? 'disabled' : '' }}">
              Category:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (template?.category) {
                    <b class="primary">{{ template.category.name }}</b>
                  } @else {
                    <span class="grey">All categories</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openCategoryFilterModal()"
                  [disabled]="!isNew || !canSelectCollectionAndCategory()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top  {{ !canSelectCollectionAndCategory() ? 'disabled' : '' }}">
              Gender:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (template?.gender) {
                    <b class="primary">{{ template.gender.name }}</b>
                  } @else {
                    <span class="grey">All genders</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openGenderFilterModal()"
                  [disabled]="!isNew || !canSelectCollectionAndCategory()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top {{ !canSelectGenderStyleGroupAndStyle() ? 'disabled' : '' }}">
              Style group:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @if (template?.styleGroup) {
                    <b class="primary">{{ template.styleGroup.name }}</b>
                  } @else {
                    <span class="grey">All style groups</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openStyleGroupFilterModal()"
                  [disabled]="!isNew || !canSelectGenderStyleGroupAndStyle()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top {{ !canSelectGenderStyleGroupAndStyle() ? 'disabled' : '' }}">
              Styles:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @for (item of template?.styles; track $index) {
                    <b class="primary">{{ item.code }}</b>
                    @if ($index < template.styles.length - 1) {
                      ,
                    }
                  } @empty {
                    <span class="grey">All styles</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openStylesFilterModal()"
                  [disabled]="!isNew || !canSelectGenderStyleGroupAndStyle()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
            <div class="flex column margin-top {{ !canSelectColors() ? 'disabled' : '' }}">
              Colors:
              <div class="flex center margin-top-smallest">
                <div class="flex-1 padding-small border bg-white">
                  @for (item of colors; track $index) {
                    <b class="primary">{{ item.name }}</b>
                    @if ($index < colors.length - 1) {
                      ,
                    }
                  } @empty {
                    <span class="grey">All colors</span>
                  }
                </div>
                <button
                  class="radius-left-none"
                  (click)="openColorsFilterModal()"
                  [disabled]="!isNew || !canSelectColors()"
                >
                  <i class="fa-solid fa-edit margin-right-small"></i>
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-0 padding">
          <i class="fa-solid fa-arrow-right big primary margin-top-large"></i>
        </div>
        <div class="flex-1 flex column">
          <div class="flex center between margin-bottom">
            <b>Shot types:</b>
          </div>
          <div class="bg-lightest-blue border padding flex column scrollable dashed">
            <div class="shot-grid">
              @for (item of template.shots; track $index) {
                <div class="padding-small flex column border radius between bg-white">
                  <div class="flex">
                    <div class="flex-0 margin-right-small">
                      <div class="placeholder" [style.background-image]="'url(null)'"></div>
                    </div>

                    <div class="flex-1 flex column">
                      <div class="flex center between">
                        <div class="flex center">
                          <b>{{ item.shotType.name }}</b>

                          @if (item.mandatory) {
                            <small
                              class="primary margin-left-smallest flex center padding-smallest"
                              matTooltip="Mandatory"
                            >
                              <i class="fa-solid fa-lock"></i>
                            </small>
                          }
                        </div>

                        @if (isNew) {
                          <i class="fa fa-xmark grey hover" (click)="removeShot($index)"></i>
                        }
                      </div>

                      <div class="flex column small">
                        <div class="flex between">
                          <div class="flex column">
                            <div>
                              {{ item.aspectRatio.id == 1 ? 'Square' : '-' }} {{ item.aspectRatio.label }},
                              {{ item.mediaFormat.code }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (isNew) {
                <div
                  class="add bg-white hover padding-small flex column border dashed radius between"
                  (click)="openAddShotModal()"
                >
                  <div class="flex center">
                    <div class="flex-0 margin-right-small">
                      <div class="placeholder flex center justify-center">
                        <i class="primary fa fa-plus fa-lg"></i>
                      </div>
                    </div>
                    <div class="flex-1 flex column">
                      <div class="flex center between primary bold">Add shot</div>
                      <span class="grey">Select shot type</span>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (loading) {
    <bt-loader></bt-loader>
  }
</div>
